import DaysOfWeekMultiSelect from 'components/common/DaysOfWeekMultiSelect';
import { DaysOfWeek } from 'enums';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateFilterDaysOfWeek } from 'store/reducer/filter/slice';

const FilterDaysOfWeekRevamp: React.FC = () => {
  const dispatch = useAppDispatch();
  const daysOfWeek = useAppSelectorShallow((state) => state.filter.daysOfWeek);

  return (
    <DaysOfWeekMultiSelect
      value={(daysOfWeek ?? []) as DaysOfWeek[]}
      onChange={(nextDays) => dispatch(updateFilterDaysOfWeek(nextDays))}
      size='md'
      placeholder={t('settings_page.search_days_of_week')}
      className='min-w-[200px]'
      btnClassName='!bg-white dark:!bg-secondary-dark-200 !text-black dark:!text-primary-50 !border-none'
    />
  );
};

export default FilterDaysOfWeekRevamp;
